// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteloader_siteloader__mVRGM {
  background: transparent linear-gradient(117deg, #A93340 0%, #A93340 100%) 0% 0% no-repeat padding-box;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

/* This centers the loader box */
.siteloader_main__qfD27 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Container for image inside the circle */
.siteloader_center__b8uLq {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/siteloader.module.css"],"names":[],"mappings":"AAAA;EACE,qGAAqG;EACrG,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC","sourcesContent":[".siteloader {\n  background: transparent linear-gradient(117deg, #A93340 0%, #A93340 100%) 0% 0% no-repeat padding-box;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n/* This centers the loader box */\n.main {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* Container for image inside the circle */\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteloader": `siteloader_siteloader__mVRGM`,
	"main": `siteloader_main__qfD27`,
	"center": `siteloader_center__b8uLq`
};
export default ___CSS_LOADER_EXPORT___;
